import { ToplistHeadline } from '../../types';

import { MetaDataContext } from './types';

type Props = {
  data: {
    toplist: ToplistHeadline;
  };
};

const expertToplists = ({ data }: Props, { t }: MetaDataContext) => {
  if (!data) {
    return {};
  }

  const { toplist } = data;

  if (!toplist?.toplists || !toplist.toplists[0]) return {};

  const description = t('meta', 'expert.toplists-description', {
    title: toplist.name.toLowerCase(),
  });

  const title = t('meta', 'expert.toplists-title', {
    title: toplist.name,
    experts:
      toplist.toplists.length === 1
        ? t('meta', 'expert.toplists-singular-expert')
        : t('meta', 'expert.toplists-plural-expert'),
    year:
      toplist.toplists[0].publishedAt &&
      new Date(parseInt(toplist.toplists[0].publishedAt, 10)).getFullYear() ===
        new Date().getFullYear()
        ? `${new Date().getFullYear()} `
        : '',
  });

  const image =
    toplist.toplists[0] &&
    toplist.toplists[0].description?.find(d => d.type === 'image')?.data;

  const openGraph = [
    { key: 'url', content: toplist.fullUrl },
    { key: 'title', content: toplist.name },
    { key: 'description', content: description },
    { key: 'type', content: 'article' },
    { key: 'image', content: image },
    { key: 'siteName', content: t('meta', 'site.name') },
  ];

  return {
    title,
    description,
    openGraph,
    structuredData: undefined,
    canonical: toplist.fullUrl,
  };
};

export default expertToplists;
